// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header-module__header___X6utd {
    background-color: var(--bmo-purple);
    height: 100px;
    color: white;
    display: flex;
    align-items: center;
    padding: 0 20px;
    position: relative;
}

.Header-module__leftText___bgoFv {
    font-size: 3rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
}

.Header-module__logoContainer___oost0 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-shrink: 0;
}

.Header-module__centerText___rD0YA {
    display: flex;
    justify-content:center;
}

.Header-module__logo___uQagN {
    width: 100px;
    height: auto;
    margin-bottom: 5px;
}

.Header-module__headerText___oASvW {
    font-size: 1.1rem;
    margin: 0;
    text-align: left;
}

@media (min-aspect-ratio: 2) {
    .Header-module__header___X6utd {
        height: 70px;
    }

    .Header-module__logo___uQagN {
        width: 70px;
    }
    .Header-module__headerText___oASvW {
        font-size: 1rem;
    }
}



.Header-module__mainNav___RAwCA {
    margin: 0 auto;
    padding: 0 20px;
    flex-shrink: 1;
    min-width: 0; /* Important for text overflow to work */
}

    .Header-module__mainNav___RAwCA ul {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
    }

    .Header-module__mainNav___RAwCA li {
        margin-right: 20px;
        cursor: pointer;
        color: white;
        transition: color 0.3s ease;
        background: none;
        padding: 0;
    }

        .Header-module__mainNav___RAwCA li:last-child {
            margin-right: 0;
        }

        .Header-module__mainNav___RAwCA li:hover {
            color: var(--bmo-primary-color-mint-dark);
        }

        .Header-module__mainNav___RAwCA li.Header-module__active___hSRlH {
            color: var(--bmo-primary-color-mint);
        }

.Header-module__navLink___spc1b {
    display: block;
}

.Header-module__navLinkEllipsis___hpJ0b {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/Header/Header.module.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;AACJ;;;;AAIA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,YAAY,EAAE,wCAAwC;AAC1D;;IAEI;QACI,gBAAgB;QAChB,SAAS;QACT,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,YAAY;QACZ,2BAA2B;QAC3B,gBAAgB;QAChB,UAAU;IACd;;QAEI;YACI,eAAe;QACnB;;QAEA;YACI,yCAAyC;QAC7C;;QAEA;YACI,oCAAoC;QACxC;;AAER;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB","sourcesContent":[".header {\n    background-color: var(--bmo-purple);\n    height: 100px;\n    color: white;\n    display: flex;\n    align-items: center;\n    padding: 0 20px;\n    position: relative;\n}\n\n.leftText {\n    font-size: 3rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    flex-shrink: 0;\n}\n\n.logoContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    flex-shrink: 0;\n}\n\n.centerText {\n    display: flex;\n    justify-content:center;\n}\n\n.logo {\n    width: 100px;\n    height: auto;\n    margin-bottom: 5px;\n}\n\n.headerText {\n    font-size: 1.1rem;\n    margin: 0;\n    text-align: left;\n}\n\n@media (min-aspect-ratio: 2) {\n    .header {\n        height: 70px;\n    }\n\n    .logo {\n        width: 70px;\n    }\n    .headerText {\n        font-size: 1rem;\n    }\n}\n\n\n\n.mainNav {\n    margin: 0 auto;\n    padding: 0 20px;\n    flex-shrink: 1;\n    min-width: 0; /* Important for text overflow to work */\n}\n\n    .mainNav ul {\n        list-style: none;\n        margin: 0;\n        padding: 0;\n        display: flex;\n    }\n\n    .mainNav li {\n        margin-right: 20px;\n        cursor: pointer;\n        color: white;\n        transition: color 0.3s ease;\n        background: none;\n        padding: 0;\n    }\n\n        .mainNav li:last-child {\n            margin-right: 0;\n        }\n\n        .mainNav li:hover {\n            color: var(--bmo-primary-color-mint-dark);\n        }\n\n        .mainNav li.active {\n            color: var(--bmo-primary-color-mint);\n        }\n\n.navLink {\n    display: block;\n}\n\n.navLinkEllipsis {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header-module__header___X6utd`,
	"leftText": `Header-module__leftText___bgoFv`,
	"logoContainer": `Header-module__logoContainer___oost0`,
	"centerText": `Header-module__centerText___rD0YA`,
	"logo": `Header-module__logo___uQagN`,
	"headerText": `Header-module__headerText___oASvW`,
	"mainNav": `Header-module__mainNav___RAwCA`,
	"active": `Header-module__active___hSRlH`,
	"navLink": `Header-module__navLink___spc1b`,
	"navLinkEllipsis": `Header-module__navLinkEllipsis___hpJ0b`
};
export default ___CSS_LOADER_EXPORT___;
